// https://stackoverflow.com/questions/11100821/javascript-regex-for-validating-filenames
// https://stackoverflow.com/questions/30251833/validating-file-name-for-creating-file-in-windows-using-regular-expression-in-j
export const forbiddenChars = /^[^\\/:*?"<>|]+$/;
export const forbiddenFileNames = /^(nul|prn|con|aux|lpt[0-9]|com[0-9])(\.|$)/i;;
